module.exports = __webpack_public_path__ + "static/media/3.887336f4.jpeg";